import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=7a4a97d8&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=7a4a97d8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a97d8",
  null
  
)

export default component.exports